var exports = {
  "WB": "DMWelcomeSection.module__welcomeSection___bjU0Yk",
  "rZ": "DMWelcomeSection.module__profileSection___bjU0Yk",
  "KI": "DMWelcomeSection.module__avatarButton___bjU0Yk",
  "xO": "DMWelcomeSection.module__usernameButton___bjU0Yk",
  "Xh": "DMWelcomeSection.module__username___bjU0Yk",
  "Yh": "DMWelcomeSection.module__welcomeText___bjU0Yk",
  "A2": "DMWelcomeSection.module__actionSection___bjU0Yk",
  "I9": "DMWelcomeSection.module__mutualGuildsContainer___bjU0Yk",
  "Ko": "DMWelcomeSection.module__guildIconWrapper___bjU0Yk",
  "$f": "DMWelcomeSection.module__guildIcon___bjU0Yk",
  "Ii": "DMWelcomeSection.module__mutualGuildsText___bjU0Yk",
  "fc": "DMWelcomeSection.module__actionButtonsContainer___bjU0Yk",
};

module.exports = exports;
